import type { LeadPriorityScore } from "app/pages/sales-intelligence/modules/lists/types/columns";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFunction } from "pro-features/components/WithTrack/src/WithTrack";

const SI_SCORING_MODULE_CATEGORY = "SI scoring";

const createScoringBoardTrackingService = (track: TrackFunction) => {
    const trackScoringClick = (eventName: string): void => {
        track(SI_SCORING_MODULE_CATEGORY, "click", eventName);
    };

    return {
        trackAddRule(priority: LeadPriorityScore) {
            trackScoringClick(createTrackingEventName("add rule", priority));
        },
        trackOpenEditRule() {
            trackScoringClick("edit rule");
        },
        trackRequestDeleteRule() {
            trackScoringClick(createTrackingEventName("delete rule", "open"));
        },
        trackConfirmDeleteRule() {
            trackScoringClick(createTrackingEventName("delete rule", "confirm"));
        },
        trackCancelDeleteRule() {
            trackScoringClick(createTrackingEventName("delete rule", "cancel"));
        },
        trackSaveRuleWizard(mode: "create" | "edit") {
            trackScoringClick(createTrackingEventName("rule save", mode));
        },
        trackSelectRule(segment?: string) {
            trackScoringClick(segment ? createTrackingEventName("select rule", segment) : "select rule");
        },
        trackChangeRulesSegmentFilter(segment: string) {
            trackScoringClick(createTrackingEventName("segment filter", segment));
        },
        trackBoardRetry() {
            trackScoringClick("retry");
        },
        trackMoveRule(targetPriority: LeadPriorityScore) {
            trackScoringClick(createTrackingEventName("move rule", targetPriority));
        },
        trackExportRules(segment: string) {
            trackScoringClick(createTrackingEventName("export rules", segment));
        },
    };
};

export default createScoringBoardTrackingService;
